module.exports = __webpack_public_path__ + "static/media/hp.aae60912.svg";